const CarouselCardInner: React.CSSProperties = {
    width: '100%',
    height: '131px',
    objectFit: 'contain',
    objectPosition: 'center',
    background: '#FFFFFF',
    display: 'block',
    textAlign: 'center',
    justifyContent: 'center',
    userSelect: 'none'
};

export default CarouselCardInner;
